// extracted by mini-css-extract-plugin
export default {"description":"_7kGHjeeW4m8sEaEfGnJ0ep"};